import React from 'react';
import { useSelector } from 'react-redux';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import { selectUserIsIdentified } from 'core/selectors/user';
import { parseBonusTrackerOffer } from 'core/modules/BonusTracker/utils/parseBonusTrackerOffer';
import { addCommas } from 'core/utils/helpers/numbers';

function PublicBonusIndicator({ publicAutomaticBonus, offer }) {
  const userIsIdentified = useSelector(selectUserIsIdentified);
  const {
    totalAmountSpentNumber, brandCurrency,
  } = parseBonusTrackerOffer(publicAutomaticBonus);

  const isBonusCompleted = offer.isFullyQualified;

  return (
    <div className={`mn_progress ${userIsIdentified ? '' : 'mn_anonymous'}`}>
      <h3>{userIsIdentified ? <>Your progress</> : <>Log in to see your progress</>}</h3>
      <div className="mn_details">
        <div className="mn_detail">
          <div className="mn_rewardValue">
            ${addCommas(totalAmountSpentNumber)} /<wbr /> {addCommas(offer.minSpendToQualify)}
          </div>
        </div>
        <div className="mn_divider" />
        <div className="mn_detail">
          <div className={`mn_icon ${isBonusCompleted ? 'mn_completed' : 'mn_inProgress'}`} />
          <div className="mn_rewardValue">
            {addCommas(offer.maxRewardAvailable)}
            <div className="mn_earnType">Bonus {brandCurrency}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><PublicBonusIndicator {...props} /></ComponentErrorBoundary>;
